import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFilter, FiX } = FiIcons;

const Sel = ({ label, value, onChange, options }) => (
  <div className="flex flex-col gap-1">
    <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</label>
    <select value={value} onChange={e => onChange(e.target.value)}
      className="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:border-blue-500 cursor-pointer min-w-32">
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

const ReportFilters = ({ filters, setFilters, raw }) => {
  // Check if any filter besides the default 'All' or current year is active
  const currentYear = new Date().getFullYear();
  const hasActive = Object.entries(filters).some(([k, v]) => {
    if (k === 'year') return v !== currentYear;
    return v && v !== 'All' && v !== '';
  });

  const upd = patch => setFilters(f => ({ ...f, ...patch }));
  const clear = () => setFilters({ department: 'All', location: 'All', manager: 'All', campaign: 'All', learner: 'All', year: currentYear });

  const { employees = [], campaigns = [] } = raw || {};
  
  const departments = [...new Set(employees.map(e => e.department).filter(Boolean))];
  const locations = [...new Set(employees.map(e => e.location).filter(Boolean))];
  const managers = [...new Set(employees.map(e => e.manager).filter(Boolean))];

  const yearOpts = [
    { value: currentYear, label: `Current Year (${currentYear})` },
    { value: currentYear - 1, label: `Previous Year (${currentYear - 1})` }
  ];

  const deptOpts = [{ value: 'All', label: 'All Departments' }, ...departments.map(d => ({ value: d, label: d }))];
  const locOpts = [{ value: 'All', label: 'All Locations' }, ...locations.map(l => ({ value: l, label: l }))];
  const mgrOpts = [{ value: 'All', label: 'All Managers' }, ...managers.map(m => ({ value: m, label: m }))];
  const campOpts = [{ value: 'All', label: 'All Campaigns' }, ...campaigns.map(c => ({ value: c.id, label: c.campaignName || 'Unnamed' }))];
  const learnerOpts = [{ value: 'All', label: 'All Learners' }, ...employees.map(l => ({ value: l.id, label: `${l.firstName || ''} ${l.lastName || ''}`.trim() || l.email }))];

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiFilter} className="text-blue-500" />
          <span className="text-sm font-semibold text-slate-700">Filters</span>
          {hasActive && <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-0.5 rounded-full">Active</span>}
        </div>
        {hasActive && (
          <button onClick={clear} className="flex items-center gap-1 text-xs text-slate-500 hover:text-red-500 transition-colors font-medium">
            <SafeIcon icon={FiX} className="text-xs" />Clear all
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-4">
        <Sel label="Year" value={filters.year} onChange={v => upd({ year: Number(v) })} options={yearOpts} />
        <Sel label="Department" value={filters.department} onChange={v => upd({ department: v })} options={deptOpts} />
        <Sel label="Location" value={filters.location} onChange={v => upd({ location: v })} options={locOpts} />
        <Sel label="Manager" value={filters.manager} onChange={v => upd({ manager: v })} options={mgrOpts} />
        <Sel label="Campaign" value={filters.campaign} onChange={v => upd({ campaign: v })} options={campOpts} />
        <Sel label="Learner" value={filters.learner} onChange={v => upd({ learner: v })} options={learnerOpts} />
      </div>
    </div>
  );
};

export default ReportFilters;